export default __webpack_public_path__ + "static/media/Achievements5.7caf57c9.webp";